import React from 'react'
import { CardFrame } from '../../../ui/CardFrame/CardFrame.jsx'
import { TypedBulletList } from '../interactions/TypedBulletList.jsx'

// Enum change: review/think/advice/vent → emotional/tactical/political/informational
const TYPE_OPTIONS = [
  { id: 'emotional',      label: 'emotional',      tone: 'berry' },
  { id: 'tactical',       label: 'tactical',       tone: 'moss' },
  { id: 'political',      label: 'political',      tone: 'mustard' },
  { id: 'informational',  label: 'informational',  tone: 'clay' },
]

/**
 * SupportCard — typed bullet list (emotional / tactical / political / informational).
 * catalog #16, prep-support. Enum change + shape-shift from chip-multi-context.
 */
export function SupportCard({ card, value, onChange, disabled }) {
  const items = value?.items ?? []
  const hasBullets = items.some((i) => i.text)

  return (
    <CardFrame
      kind="prep"
      icon="○"
      iconClass="berry"
      title="Support needed"
      prompt="What kind of support do you need?"
      state={disabled ? 'locked' : hasBullets ? 'filled' : 'empty'}
      data-testid="prep-card-prep-support"
      className="prepcard"
    >
      <TypedBulletList
        items={items}
        onChange={onChange}
        typeOptions={TYPE_OPTIONS}
        maxItems={8}
        maxChars={140}
        placeholder="Something you could use support on…"
        disabled={disabled}
        required
      />
    </CardFrame>
  )
}
